import { Title, EscapeLink, Item, List, Outer } from './shared'

type RegionLinksProps = {
  marketName: string
  country: {
    id: string
    code: string
  }
  regions: Array<{
    id: string
    name: string
    slug: string
    state: {
      id: string
      code: string
    }
  }>
}

const RegionLinks = ({ marketName, country, regions }: RegionLinksProps) => {
  const countryCode = country?.code

  return (
    <Outer>
      <Title>Explore {marketName}</Title>
      <List>
        {regions?.map(({ id, name, slug, state }) => {
          return (
            <Item key={id}>
              <EscapeLink
                to={{
                  pathname: '/listings',
                  search: `?type=accommodation&country=${countryCode}&state=${state.code}&regions[]=${slug}`,
                  state: {
                    scrollTop: true,
                  },
                }}
              >
                {name}
              </EscapeLink>
            </Item>
          )
        })}
      </List>
    </Outer>
  )
}

export default RegionLinks
